import { FunctionalComponent, h } from 'preact';

import { media } from '../../styles';
import styled from 'styled-components';

type Props = {
  minHeight?: number;
  withFadingTop?: boolean;
  withFadingBottom?: boolean;
};

const VerticalScrollerWrapper = styled.div<Props>`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  z-index: 1;
  ${({ minHeight }) => (minHeight ? `min-height: ${minHeight}px` : '')};
  ${media.ie11} {
    /* IE10+ CSS styles go here */
    height: auto;
    max-height: 70%;
    min-height: ${({ minHeight }) => (minHeight ? `${minHeight}px` : '80px')};
    overflow: auto;

    -ms-flex: 1 1 100%;
  }

  ${media.mobilePortrait} {
    overflow: auto;
  }

  ${media.mobileLandscape} {
    overflow: auto;
  }

  ${media.mobilePortraitXS} {
    max-height: initial;
    min-height: initial;
  }
`;

const fadingStyle = `
  content: '';
  display: block;
  height: 20px;
  left: 2%;
  pointer-events: none;
  position: absolute;
  right: 2%;
  width: 96%;
  z-index: 10;
`;

const before = `
  &:before {
    background: linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%);
    top: 0;
    ${fadingStyle}
  }
`;

const after = `
  &:after {
    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
    bottom: 0;
    ${fadingStyle}
  }
`;

const FadingWrapper = styled.div<Props>`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  padding-top: 1px;
  padding-bottom: 1px;
  position: relative;
  overflow: hidden;

  ${({ withFadingBottom }) => (withFadingBottom ? after : '')}
  ${({ withFadingTop }) => (withFadingTop ? before : '')}
`;

const VerticalScroller: FunctionalComponent<Props> = ({
  children,
  minHeight,
  withFadingTop = false,
  withFadingBottom = false,
}) => {
  const content = (
    <VerticalScrollerWrapper data-testid="uc-vertical-scroller" minHeight={minHeight}>
      {children}
    </VerticalScrollerWrapper>
  );

  if (!withFadingTop && !withFadingBottom) {
    return content;
  }

  return (
    <FadingWrapper withFadingBottom={withFadingBottom} withFadingTop={withFadingTop}>
      {content}
    </FadingWrapper>
  );
};

export default VerticalScroller;
